import React, { useState, useRef } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  TextField,
  Box,
  CircularProgress,
  Container,
  Stack,
} from '@mui/material';
import axios from '../axios';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import SweetAlert from 'react-bootstrap-sweetalert';
import forgot from '../assets/img/forgot.jpg';
import './ForgotPassword.css';

const steps = ['Enter Email', 'Verify OTP', 'Reset Password'];

const emailValidationSchema = yup.object({
  email: yup
    .string()
    .email('Enter a valid email')
    .required('Email is required'),
});

const otpValidationSchema = yup.object({
  otp: yup
    .string()
    .matches(/^\d{4}$/, 'Enter a valid 4-digit OTP')
    .required('OTP is required'),
});

const passwordValidationSchema = yup.object({
  newpassword: yup
    .string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{5,8}$/,
      'Password must be 5-8 characters long and include at least one Uppercase , one Lowercase , one number and one symbol',
    )
    .required('New Password is required'),
  confirmpassword: yup
    .string()
    .oneOf([yup.ref('newpassword'), null], 'Passwords must match')
    .required('Confirm Password is required'),
});

function ForgotPassword() {
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);
  const [openLoader, setOpenLoader] = useState(false);
  const [mailSent, setMailSent] = useState(false);
  const [notWorking, setnotWorking] = useState(false);
  const [success, setsuccess] = useState(false);
  const [verifysuccess, setverifysuccess] = useState(false);
  const [otpCode, setOtpCode] = useState('');
  const [cusid, setCusId] = useState('');

  const formikEmail = useFormik({
    initialValues: { email: '' },
    validationSchema: emailValidationSchema,
    onSubmit: values => {
      Forgotpassword(values.email);
    },
  });

  const formikOtp = useFormik({
    initialValues: { otp: '' },
    validationSchema: otpValidationSchema,
    onSubmit: values => {
      verifyOtp(values.otp);
    },
  });

  const formikPassword = useFormik({
    initialValues: {
      newpassword: '',
      confirmpassword: '',
    },
    validationSchema: passwordValidationSchema,
    onSubmit: values => {
      Updatepassword(values.newpassword, values.confirmpassword);
    },
  });

  const Forgotpassword = async email => {
    setOpenLoader(true);
    if (email.length !== 0) {
      const tokent = sessionStorage.getItem('authtoken');
      try {
        const res = await axios.instance.get(`/GetEmailId/${email}`, {
          Authorization: tokent,
          'Content-Type': 'application/json',
        });
        if (res.data.length > 0) {
          setCusId(res.data[0].User_Id);
          MailForOTP(res.data[0].User_Id);
          setOpenLoader(false);
          setMailSent(true);
          handleNext();
        } else {
          setnotWorking(true);
          setOpenLoader(false);
        }
      } catch (error) {
        setnotWorking(true);
        setOpenLoader(false);
      }
    }
    setOpenLoader(false);
  };

  const MailForOTP = async cusid => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.post(`MailForOTP/${cusid}`);
      setOtpCode(res.data.otpCode);
      if (res.data.message === 'Email sent successfully') {
        setMailSent(true);
      } else {
        setnotWorking(true);
      }
      setOpenLoader(false);
    } catch (error) {
      setnotWorking(true);
      setOpenLoader(false);
    }
  };

  const verifyOtp = enteredOtp => {
    setOpenLoader(true);
    if (enteredOtp === otpCode.toString()) {
      setverifysuccess(true);
      setOpenLoader(false);
      handleNext();
    } else {
      setnotWorking(true);
      setOpenLoader(false);
    }
  };

  const Updatepassword = async (newpassword, confirmpassword) => {
    setOpenLoader(true);
    if (newpassword === confirmpassword) {
      try {
        const response = await axios.instance.post('Updatepass', {
          NewPassword: confirmpassword,
          customer_id: cusid,
        });
        setsuccess(true);
        handleNext();
        setOpenLoader(false);
      } catch (error) {
        setnotWorking(true);
        setOpenLoader(false);
      }
    } else {
      setnotWorking(true);
      setOpenLoader(false);
    }
  };

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  return (
    <div fullWidth className="w-100 h-100 p-0 m-0 bg-white">
      <Container maxWidth="sm">
        <Stack justifyContent={'center'} alignItems={'center'}>
          <button
            className="button"
            onClick={() => {
              history.push('/');
            }}
          >
            T O M P G
          </button>

          <p
            style={{
              color: '#04364A',
              fontSize: 20,
              fontWeight: '600',
              color: '#04364A',
              fontSize: 20,
              fontWeight: '600',
              textAlign: 'center',
            }}
            className="text-style22"
          >
            Forgot Password?
          </p>
          <img
            src={forgot}
            style={{
              maxWidth: '300px',
              minHeight: '50vh',
              maxHeight: '100vh',
              objectFit: 'contain',
              mixBlendMode: 'multiply',
            }}
            alt="login"
          />
          <p
            style={{
              color: '#04364A',
              fontSize: 20,
              fontWeight: '600',
              color: '#04364A',
              fontSize: 20,
              fontWeight: '600',
              textAlign: 'center',
            }}
            className="text-style22"
          >
            Please Enter your email to proceed with password reset.
          </p>
          <Box sx={{ width: '100%', my: 4 }}>
            <Stepper activeStep={activeStep}>
              {steps.map((label, index) => (
                <Step key={index}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            {openLoader && <CircularProgress />}
            {activeStep === 0 && (
              <form onSubmit={formikEmail.handleSubmit}>
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  label="Email"
                  value={formikEmail.values.email}
                  onChange={formikEmail.handleChange}
                  error={
                    formikEmail.touched.email &&
                    Boolean(formikEmail.errors.email)
                  }
                  helperText={
                    formikEmail.touched.email && formikEmail.errors.email
                  }
                  margin="normal"
                />
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                >
                  Send Email
                </Button>
              </form>
            )}
            {activeStep === 1 && (
              <form onSubmit={formikOtp.handleSubmit}>
                <TextField
                  fullWidth
                  id="otp"
                  name="otp"
                  label="OTP"
                  value={formikOtp.values.otp}
                  onChange={formikOtp.handleChange}
                  error={formikOtp.touched.otp && Boolean(formikOtp.errors.otp)}
                  helperText={formikOtp.touched.otp && formikOtp.errors.otp}
                  margin="normal"
                />
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                >
                  Verify OTP
                </Button>
              </form>
            )}
            {activeStep === 2 && (
              <form onSubmit={formikPassword.handleSubmit}>
                <TextField
                  fullWidth
                  id="newpassword"
                  name="newpassword"
                  label="New Password"
                  type="password"
                  value={formikPassword.values.newpassword}
                  onChange={formikPassword.handleChange}
                  error={
                    formikPassword.touched.newpassword &&
                    Boolean(formikPassword.errors.newpassword)
                  }
                  helperText={
                    formikPassword.touched.newpassword &&
                    formikPassword.errors.newpassword
                  }
                  margin="normal"
                />
                <TextField
                  fullWidth
                  id="confirmpassword"
                  name="confirmpassword"
                  label="Confirm Password"
                  type="password"
                  value={formikPassword.values.confirmpassword}
                  onChange={formikPassword.handleChange}
                  error={
                    formikPassword.touched.confirmpassword &&
                    Boolean(formikPassword.errors.confirmpassword)
                  }
                  helperText={
                    formikPassword.touched.confirmpassword &&
                    formikPassword.errors.confirmpassword
                  }
                  margin="normal"
                />
                <Button
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                >
                  Reset Password
                </Button>
              </form>
            )}
          </Box>
        </Stack>
        {mailSent && (
          <SweetAlert
            title="OTP Sent Successfully"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setMailSent(false);
            }}
          />
        )}
        {notWorking && (
          <SweetAlert
            title="Unable To Process"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            error
            onConfirm={() => {
              setnotWorking(false);
            }}
          />
        )}
        {success && (
          <SweetAlert
            title="Password Update Successfully"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setsuccess(false);
              history.push('/');
            }}
          />
        )}
        {verifysuccess && (
          <SweetAlert
            title="OTP Verified Successfully"
            timeout={2000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setverifysuccess(false);
              // handleNext();
            }}
          />
        )}
      </Container>
    </div>
  );
}
export default ForgotPassword;
